import { useTranslation } from 'react-i18next'

import { getManagerProfileOptions } from '../../../../../api'
import { useScreen } from '../../../../../hooks'
import { getItemsFromIdwellApiResponse } from '../../../../../utils/api'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { toUserSelectItemsFromOption, UserSelect } from '../../../../User'
import { REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_MANAGER } from '../../RequestWizardForm.constants'

function ManagerField({ controlProps, isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={FormFieldSelectNG}
      Select={UserSelect}
      controlProps={{
        ...controlProps,
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Wizard.ResponsibleManagerPlaceholderKey'),
          },
        },
      }}
      disabled={isLoading}
      fieldComponentProps={{
        disabled: isLoading,
        info: t('Wizard.ResponsibleManagerInfoKey'),
        label: `${t('Wizard.ResponsibleManagerLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getData={getManagerProfileOptions}
      getDataItems={getItemsFromIdwellApiResponse}
      getErrorProps={getFormikFormFieldErrorProps}
      name={REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_MANAGER}
      toPreparedItems={toUserSelectItemsFromOption}
    />
  )
}

export default ManagerField
